"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination = /** @class */ (function () {
    function Pagination(rootElement) {
        this.rootElement = rootElement;
    }
    Pagination.prototype.updatePagination = function (numberOfPages, currentPage, pages) {
        this.numberOfPages = numberOfPages;
        this.currentPage = currentPage;
        this.pages = pages;
        this.generatePagination();
    };
    Pagination.prototype.createPagination = function (element, numberOfPages, currentPage, showStartEndArrows, onClick, pages) {
        var pagination = new Pagination(this.rootElement);
        pagination.numberOfPages = numberOfPages;
        pagination.element = element;
        pagination.currentPage = currentPage;
        pagination.showStartEndArrows = showStartEndArrows;
        pagination.pages = pages;
        pagination.onClick = onClick;
        pagination.generatePagination();
        return pagination;
    };
    Pagination.prototype.generatePagination = function () {
        var _this = this;
        this.element.innerHTML = '';
        if (this.pages) {
            this.numberOfPages = this.pages.length;
        }
        var str = '<ul class="c-pagination">';
        var active;
        var pageCutLow = this.currentPage - 1;
        var pageCutHigh = this.currentPage + 1;
        if (this.showStartEndArrows && this.currentPage > 1) {
            str += '<li class="c-pagination__item"><a class="c-pagination__link" data-page="' + 1 + '"><i class="mdi mdi-arrow-collapse-left"></i></a></li>';
        }
        // Show the Previous button only if you are on a page other than the first
        if (this.currentPage > 1) {
            str += '<li class="c-pagination__item"><a class="c-pagination__link" data-page="' + (this.currentPage - 1) + '"><i class="mdi mdi-chevron-left"></i></a></li>';
        }
        // Show all the pagination elements if there are less than 6 pages total
        if (this.numberOfPages < 6) {
            for (var p = 1; p <= this.numberOfPages; p++) {
                active = this.currentPage == p ? "is-current" : "";
                str += '<li class="c-pagination__item"><a class="c-pagination__link ' + active + '"  data-page="' + p + '">' + p + '</a></li>';
            }
        }
        // Use "..." to collapse pages outside of a certain range
        else {
            // Show the very first page followed by a "..." at the beginning of the
            // pagination section (after the Previous button)
            if (this.currentPage > 2) {
                str += '<li class="c-pagination__item"><a class="c-pagination__link" data-page="' + 1 + '">1</a></li>';
                if (this.currentPage > 3) {
                    str += '<li class="c-pagination__item"><a class="c-pagination__link c-pagination__link--no-background" data-page="' + (this.currentPage - 2) + '">...</a></li>';
                }
            }
            // Determine how many pages to show after the current page index
            if (this.currentPage === 1) {
                pageCutHigh += 2;
            }
            else if (this.currentPage === 2) {
                pageCutHigh += 1;
            }
            // Determine how many pages to show before the current page index
            if (this.currentPage === this.numberOfPages) {
                pageCutLow -= 2;
            }
            else if (this.currentPage === this.numberOfPages - 1) {
                pageCutLow -= 1;
            }
            // Output the indexes for pages that fall inside the range of pageCutLow
            // and pageCutHigh
            for (var p = pageCutLow; p <= pageCutHigh; p++) {
                if (p === 0) {
                    p += 1;
                }
                if (p > this.numberOfPages) {
                    continue;
                }
                active = this.currentPage == p ? "is-current" : "";
                str += '<li class="c-pagination__item"><a class="c-pagination__link ' + active + '" data-page="' + p + '">' + p + '</a></li>';
            }
            // Show the very last page preceded by a "..." at the end of the pagination
            // section (before the Next button)
            if (this.currentPage < this.numberOfPages - 1) {
                if (this.currentPage < this.numberOfPages - 2) {
                    str += '<li class="c-pagination__item"><a class="c-pagination__link c-pagination__link--no-background" data-page="' + (this.currentPage + 2) + '">...</a></li>';
                }
                str += '<li class="c-pagination__item"><a class="c-pagination__link" data-page="' + this.numberOfPages + '">' + this.numberOfPages + '</a></li>';
            }
        }
        // Show the Next button only if you are on a page other than the last
        if (this.currentPage < this.numberOfPages) {
            str += '<li class="c-pagination__item"><a class="c-pagination__link" data-page="' + (this.currentPage + 1) + '"><i class="mdi mdi-chevron-right"></i></a></li>';
        }
        if (this.showStartEndArrows && this.currentPage < this.numberOfPages) {
            str += '<li class="c-pagination__item"><a class="c-pagination__link" data-page="' + (this.numberOfPages) + '"><i class="mdi mdi-arrow-collapse-right"></i></a></li>';
        }
        str += '</ul>';
        // Return the pagination string to be outputted in the pug templates
        this.element.innerHTML = str;
        // Add click event for links
        var links = this.element.querySelectorAll('.c-pagination__link');
        links.forEach(function (link) {
            var pageNumber = link.dataset.page;
            link.addEventListener('click', function (event) {
                if (pageNumber) {
                    var clickedPage = null;
                    if (_this.pages) {
                        clickedPage = _this.pages[pageNumber - 1];
                    }
                    var onClick = clickedPage && clickedPage.onClick ? clickedPage.onClick : _this.onClick;
                    if (onClick) {
                        onClick(pageNumber);
                    }
                    else if (clickedPage && clickedPage.url) {
                        window.location = clickedPage.url;
                    }
                    _this.updatePagination(_this.numberOfPages, parseInt(link.dataset.page), _this.pages);
                }
            });
        });
    };
    return Pagination;
}());
exports.default = Pagination;
